import { makeStyles } from "$components/mui-styles";
import { PriceListItemType } from "../types";

const useStyles = makeStyles<InvoiceLineItemColorProps>((theme) => ({
  root: {
    width: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    borderRadius: "2px",
    background: ({ type }) => {
      switch (type) {
        case PriceListItemType.PROCEDURE:
          return theme.palette.purple.light;
        case PriceListItemType.PRESCRIPTION:
          return theme.palette.pink.dark;
        case PriceListItemType.INVESTIGATION:
          return theme.palette.blue.dark;
        case PriceListItemType.CONSULTATION:
          return theme.palette.primary.dark;
        case PriceListItemType.OTHER:
          return theme.palette.purple.dark;
        default:
          // Unknown/unresolved type — neutral grey rather than brand teal so
          // an as-yet-unresolved item doesn't read like a loading skeleton.
          return theme.palette.grey[300];
      }
    },
    display: "inline-block",
    height: "100%",
  },
}));

interface InvoiceLineItemColorProps {
  type: string;
}

export const InvoiceLineItemColor = ({ type }: InvoiceLineItemColorProps) => {
  const classes = useStyles({ type });
  return (
    <span className={classes.root} data-testid="invoicing.lineItem.color">
      &nbsp;
    </span>
  );
};
